import {
  NotificationsListResponse,
  NotificationType,
} from '../client/ria-multi-agent-system.schemas'

export const notificationsListResponseMock: NotificationsListResponse = {
  total: 4,
  notifications: [
    {
      // TODO: make mandatory in API
      id: '1212',
      message: 'Something happened',
      type: NotificationType.TaskCreated,
      // TODO: make mandatory in API
      created_at: '2025-11-19T09:00:00Z',
      // TODO: make mandatory in API
      read: false,
      // TODO: make mandatory in API
      recipient_email: 'fasdf@fasdf.com',
      // TODO: maybe make mandatory in API
      task_id: '37e3b52b-8093-4eb3-b297-6539d5c5f3a0',
    },
    {
      id: '121111',
      message: "It's overdue",
      type: NotificationType.TaskOverdue,
      created_at: '2025-11-19T09:00:00Z',
      read: false,
      recipient_email: 'fasdf@fasdf.com',
      task_id: 'fasdfsdf',
    },
  ],
}
